import { queryClient } from '@jotta/query'
import type {
  MethodUnaryDescriptor,
  UseQueryOptions,
} from '@connectrpc/connect-query'
import {
  callUnaryMethod,
  createConnectQueryKey,
} from '@connectrpc/connect-query'
import type { Message, PartialMessage } from '@bufbuild/protobuf'
import type { Transport } from '@connectrpc/connect'
import { ContentRef } from '@jotta/grpc-connect-openapi/ref'
import { Base64 } from 'js-base64'

export async function query<I extends Message<I>, O extends Message<O>>(
  descriptor: MethodUnaryDescriptor<I, O>,
  data: PartialMessage<I>,
  transport: Transport,
): Promise<O> {
  return await queryClient.fetchQuery({
    queryKey: createConnectQueryKey(descriptor, data),
    queryFn: context =>
      callUnaryMethod(descriptor, data, {
        transport,
      }),
  })
}

export async function mutate<I extends Message<I>, O extends Message<O>>(
  descriptor: MethodUnaryDescriptor<I, O>,
  data: PartialMessage<I>,
  transport: Transport,
): Promise<O> {
  return callUnaryMethod(descriptor, data, {
    transport,
  })
}

export type ConnectQueryOptions<O extends Message<O>> = Omit<
  UseQueryOptions<any, O, O>,
  'transport'
>

export function contentRefLink(ref: PartialMessage<ContentRef>['ref']) {
  const encodedRef = Base64.fromUint8Array(
    new ContentRef({
      ref,
    }).toBinary(),
    true,
  )
  return `${window.location.origin}/r/${encodedRef}`
}
